import { Controller } from '@hotwired/stimulus'
import advancedFilterController from '../advanced_filter_controller'
import buttonToggleController from '../button_toggle_controller'
import countCheckboxesController from '../count_checkboxes_controller'

export default class extends Controller {
  static outlets = ['advanced-filter', 'button-toggle', 'count-checkboxes']

  declare readonly advancedFilterOutlet: advancedFilterController
  declare readonly buttonToggleOutlet: buttonToggleController
  declare readonly hasButtonToggleOutlet: boolean
  declare readonly countCheckboxesOutlet: countCheckboxesController
  declare readonly hasCountCheckboxesOutlet: boolean

  connect (): void {
    if (!this.hasButtonToggleOutlet || !this.hasCountCheckboxesOutlet) return

    this.buttonToggleOutlet.toggleWhenChecked()
    this.countCheckboxesOutlet.updateCounter()
  }

  fetchRecords (event: Event): void {
    this.advancedFilterOutlet.submitForm(event)
  }
}
